<div class="page-container">
  <div class="max-content-width spaced-sections">
    <!-- Header -->
    <div class="flex justify-between items-start">
      <div>
        <h1 class="page-title">Projects</h1>
        <p class="page-subtitle">View and manage all research projects across your groups.</p>
      </div>
      <button type="button" (click)="openProjectCreateModal()" class="btn-primary mt-3">
        Create Project
      </button>
    </div>

    <!-- Search and Filters Section -->
    <section class="card card-padding">
      <div class="section-spacing">
        <!-- Search Bar -->
        <div class="input-group">
          <label class="input-label">Search Projects</label>
          <input
            type="text"
            [value]="searchQuery()"
            (input)="onSearchChange($any($event.target).value)"
            placeholder="Search by project title, description, group, or PI..."
            class="input-field"
          />
        </div>

        <!-- Filter Row -->
        <div class="filter-grid">
          <!-- Group Filter -->
          <div class="input-group">
            <label class="input-label">Group</label>
            <select
              [ngModel]="selectedGroup()"
              (ngModelChange)="onGroupChange($event)"
              class="select-field"
            >
              <option value="">All Groups</option>
              @for (group of groups; track group.id) {
                <option [value]="group.id">{{ group.name }}</option>
              }
            </select>
          </div>

          <!-- Stage Filter -->
          <div class="input-group">
            <label class="input-label">Stage</label>
            <select
              [ngModel]="selectedState()"
              (ngModelChange)="onStateChange($event)"
              class="select-field"
            >
              <option value="">All Stages</option>
              @for (state of states; track state) {
                <option [value]="state">
                  {{ formatState(state) }}
                </option>
              }
            </select>
          </div>

          <!-- Date Range Filter -->
          <div class="input-group">
            <label class="input-label">Created</label>
            <select
              [ngModel]="selectedDateRange()"
              (ngModelChange)="onDateRangeChange($event)"
              class="select-field"
            >
              @for (range of dateRanges; track range.value) {
                <option [value]="range.value">{{ range.label }}</option>
              }
            </select>
          </div>

          <!-- Clear Filters Button -->
          <div class="flex items-end">
            @if (hasActiveFilters()) {
              <button type="button" (click)="clearFilters()" class="btn-secondary btn-full-width">
                Clear Filters
              </button>
            }
          </div>
        </div>
      </div>
    </section>

    <!-- Results Count -->
    <div class="flex-between">
      <p class="results-counter">
        Showing
        <span class="results-counter-count">{{ totalItems() }}</span>
        @if (totalItems() === 1) {
          project
        } @else {
          projects
        }
      </p>
    </div>

    <!-- Projects Grid -->
    @if (loading()) {
      <div class="section-spacing">
        <div class="loading-skeleton"></div>
        <div class="loading-skeleton"></div>
        <div class="loading-skeleton"></div>
      </div>
    } @else if (totalItems() === 0) {
      <section class="card card-padding">
        <div class="empty-state">
          <div class="empty-state-icon">🔬</div>
          <h3 class="empty-state-title">No projects found</h3>
          <p class="empty-state-message">
            @if (hasActiveFilters()) {
              No projects match your filters. Try adjusting your search or filters.
            } @else {
              You don't have any projects yet. Once projects are created in your groups, they will
              appear here.
            }
          </p>
        </div>
      </section>
    } @else {
      <div class="section-spacing">
        @for (project of projects(); track project.id) {
          <app-project-card
            [project]="project"
            [userRole]="getUserRole(project.id)"
            [canEdit]="canEditProject(project)"
            (viewDetails)="viewProjectDetails(project)"
            (edit)="editProject(project)"
            (leaveProject)="onLeaveProject($event)"
          ></app-project-card>
        }
      </div>

      @if (totalPages() > 1) {
        <div class="flex items-center justify-between px-2 py-3 text-sm text-gray-600">
          <button
            type="button"
            (click)="goToPage(currentPage() - 1)"
            [disabled]="!canPrev()"
            class="btn-small-secondary disabled:cursor-not-allowed disabled:opacity-40"
          >
            « Prev
          </button>
          <span>Page {{ currentPage() + 1 }} of {{ totalPages() }}</span>
          <button
            type="button"
            (click)="goToPage(currentPage() + 1)"
            [disabled]="!canNext()"
            class="btn-small-secondary disabled:cursor-not-allowed disabled:opacity-40"
          >
            Next »
          </button>
        </div>
      }
    }
  </div>
</div>

<app-project-create-modal
  [open]="projectCreateModalOpen"
  (openChange)="projectCreateModalOpen = $event"
  (created)="onProjectCreated($event)"
></app-project-create-modal>

<app-confirm-modal
  [open]="showLeaveProjectConfirm"
  [title]="'Leave project?'"
  [message]="leaveProjectMessage"
  [confirmText]="'Leave project'"
  [cancelText]="'Cancel'"
  [confirmVariant]="'danger'"
  [loading]="leaveProjectLoading"
  size="sm"
  (openChange)="showLeaveProjectConfirm = $event"
  (confirmed)="confirmLeaveProject()"
  (canceled)="cancelLeaveProject()"
></app-confirm-modal>

@if (leaveProjectError) {
  <div class="mt-4 rounded-md border border-red-200 bg-red-50 p-3">
    <p class="text-sm text-red-700">{{ leaveProjectError }}</p>
  </div>
}
